import { render, staticRenderFns } from "./ConsumptionBox.vue?vue&type=template&id=aaf95958&scoped=true&"
import script from "./ConsumptionBox.vue?vue&type=script&lang=js&"
export * from "./ConsumptionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf95958",
  null
  
)

export default component.exports